var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    clipPath: "url(#clip0_2589_9221)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.9922 0H0V12H17.9922V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.99957 3.14551C7.77627 3.14551 6.7307 3.90122 6.3028 4.97268C6.3028 4.97786 6.30108 4.98303 6.29935 4.98994C6.23379 5.3954 6.29245 5.83537 6.53573 6.16837C6.78073 6.50654 7.19827 6.69979 7.61581 6.71359C8.03336 6.72739 8.44572 6.57038 8.77872 6.31848C9.01165 6.14076 9.21006 5.91819 9.45507 5.75945C9.73285 5.57829 10.0693 5.48685 10.4006 5.50237C10.599 5.511 10.7991 5.55759 10.9717 5.65938C11.3029 5.85435 11.4945 6.22876 11.5583 6.60834C11.6032 6.87577 11.5928 7.14838 11.5669 7.41927C11.7843 7.01208 11.9068 6.54795 11.9068 6.05449C11.9068 4.44989 10.6059 3.14896 9.00129 3.14896L8.99957 3.14551Z",
    fill: "#CD2E3A"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.5573 6.60294C11.4934 6.22509 11.3019 5.84895 10.9706 5.65399C10.7981 5.55219 10.5997 5.5056 10.3995 5.49698C10.0683 5.48317 9.73355 5.57462 9.45404 5.75406C9.20903 5.91279 9.01061 6.13709 8.77769 6.31308C8.44469 6.56498 8.03233 6.72199 7.61478 6.70819C7.19724 6.69439 6.7797 6.50115 6.5347 6.16297C6.29314 5.82997 6.23276 5.39 6.29832 4.98454C6.29832 4.97936 6.30005 4.97419 6.30177 4.96729C6.16892 5.30028 6.09473 5.66434 6.09473 6.04565C6.09473 7.65025 7.39566 8.95118 9.00026 8.95118C10.1114 8.95118 11.0776 8.3266 11.5659 7.41042C11.5918 7.13954 11.6039 6.86693 11.5573 6.59949V6.60294Z",
    fill: "#0047A0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.62735 2.08155L4.0166 4.43311L4.40805 4.70124L6.0188 2.34968L5.62735 2.08155Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.12051 1.73487L3.50977 4.08643L3.90122 4.35456L5.51197 2.003L5.12051 1.73487Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.61368 1.38819L3.00293 3.73975L3.39438 4.00788L5.00513 1.65632L4.61368 1.38819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.6541 9.26712L12.917 10.3433L13.3084 10.6114L14.0456 9.53526L13.6541 9.26712Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.1492 8.91898L12.4121 9.99512L12.8036 10.2633L13.5407 9.18711L13.1492 8.91898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.6424 8.57376L11.9053 9.6499L12.2967 9.91804L13.0338 8.8419L12.6424 8.57376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.5701 7.9224L13.833 8.99854L14.2245 9.26667L14.9616 8.19053L14.5701 7.9224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M14.0623 7.57572L13.3252 8.65186L13.7166 8.91999L14.4538 7.84385L14.0623 7.57572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M13.5565 7.22904L12.8193 8.30518L13.2108 8.57331L13.9479 7.49717L13.5565 7.22904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M4.07011 7.45137L5.56152 9.88037L5.96587 9.6321L4.47446 7.2031L4.07011 7.45137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M4.43051 9.21115L5.03809 10.2007L5.44243 9.95242L4.83485 8.96288L4.43051 9.21115Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M3.54522 7.77176L4.30176 9.00391L4.7061 8.75564L3.94956 7.52349L3.54522 7.77176Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M3.02421 8.09395L4.51562 10.5229L4.91997 10.2747L3.42856 7.84568L3.02421 8.09395Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M13.9015 3.04663L14.584 4.1582L14.9883 3.90994L14.3058 2.79836L13.9015 3.04663Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M12.8556 3.68969L13.5381 4.80127L13.9424 4.553L13.2599 3.44143L12.8556 3.68969Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M13.046 1.6643L13.7285 2.77588L14.1329 2.52761L13.4503 1.41604L13.046 1.6643Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M12.5208 1.9848L14.0547 4.48291L14.459 4.23464L12.9252 1.73654L12.5208 1.9848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M11.9991 2.30737L12.6816 3.41895L13.086 3.17068L12.4035 2.0591L11.9991 2.30737Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_9221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.9922,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKo);
export default __webpack_public_path__ + "static/media/ko.0dac2cc3e94e7b808530dd12d8dd26a2.svg";
export { ForwardRef as ReactComponent };